import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="bg-[#F5F2EE] border-b border-[#1C1C1C]/8">
        <div className="max-w-7xl mx-auto px-8 md:px-14 py-16 md:py-24">
          <nav className="flex items-center gap-2 text-xs text-[#1C1C1C]/35 mb-8">
            <Link to="/" className="hover:text-[#ec3145] transition-colors cursor-pointer">მთავარი</Link>
            <i className="ri-arrow-right-s-line text-[10px]"></i>
            <span className="text-[#1C1C1C]/55">გამოყენების პირობები</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-[#1C1C1C] tracking-tight mb-4">
            გამოყენების პირობები
          </h1>
          <p className="text-[#1C1C1C]/45 text-base md:text-lg max-w-2xl">
            ეს პირობები არეგულირებს თქვენს ურთიერთობას Phoenix Georgia-სთან. გთხოვთ, ყურადღებით გაეცნოთ მათ.
          </p>
          <p className="text-xs text-[#1C1C1C]/25 mt-6">ბოლო განახლება: 27 აპრილი, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-8 md:px-14 py-16 md:py-24">
        <div className="prose prose-lg max-w-none">
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">1. მიღება და თანხმობა</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              ვებსაიტის (phoenix.ge) ან/და ჩვენი მომსახურებების გამოყენებით, თქვენ ეთანხმებით ამ გამოყენების პირობებს და ჩვენს კონფიდენციალურობის პოლიტიკას. თუ არ ეთანხმებით ამ პირობებს, გთხოვთ, არ გამოიყენოთ ჩვენი ვებსაიტი და მომსახურებები.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              ჩვენ ვიტოვებთ უფლებას, ნებისმიერ დროს შევცვალოთ ეს პირობები. ცვლილებები ძალაში შედის მათი გამოქვეყნებისთანავე. ვებსაიტის გამოყენების გაგრძელება ცვლილებების შემდეგ ნიშნავს თქვენს თანხმობას განახლებულ პირობებზე.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">2. ინტელექტუალური საკუთრება</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              ვებსაიტზე განთავსებული ყველა მასალა, მათ შორის ტექსტი, გამოსახულებები, ლოგოები, ვიდეოები, პროდუქტის ფოტოები, ბრენდის სახელები და სხვა კონტენტი, არის Phoenix Georgia-ს საკუთრება ან ლიცენზირებულია და დაცულია საქართველოსა და საერთაშორისო საავტორო უფლებების კანონმდებლობით.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              თქვენ არ გაქვთ უფლება გააკეთოთ ასლი, გაავრცელოთ, შეცვალოთ, გამოაქვეყნოთ ან სხვაგვარად გამოიყენოთ ვებსაიტის კონტენტი ჩვენი წინასწარი წერილობითი თანხმობის გარეშე. ბრენდის სახელები და ლოგოები, რომლებიც ჩვენს ვებსაიტზეა განთავსებული, არის შესაბამისი მესამე მხარეების საკუთრება.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">3. პროდუქტებისა და მომსახურებების აღწერა</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              ჩვენ ვცდილობთ, რომ ვებსაიტზე განთავსებული პროდუქტებისა და მომსახურებების აღწერა იყოს ზუსტი და აქტუალური. თუმცა, ჩვენ არ ვიძლევით გარანტიას, რომ ყველა ინფორმაცია აბსოლუტურად ზუსტია.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              პროდუქტის ფოტოები შესაძლოა ოდნავ განსხვავდებოდეს რეალური პროდუქტისგან განათების, მონიტორის პარამეტრების ან სხვა ფაქტორების გამო. ფერებისა და ტექსტურების ზუსტი შესაბამისობისთვის გთხოვთ, მოითხოვოთ ფიზიკური ნიმუში ან ეწვიოთ ჩვენს შოურუმს.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              ფასები შესაძლოა შეიცვალოს უწყების გარეშე. ყველა ფასი მითითებულია ქართულ ლარში (GEL) და მოიცავს დღგ-ს, თუ სხვა რამ არ არის მითითებული.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">4. შეკვეთები და გადახდა</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              შეკვეთის გაფორმებისას თქვენ ვალდებული ხართ მოგვაწოდოთ ზუსტი და სრული ინფორმაცია, მათ შორის საკონტაქტო მონაცემები და მიწოდების მისამართი. შეკვეთის დადასტურების შემდეგ თქვენ მიიღებთ დადასტურების ელფოსტას.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              გადახდის მეთოდები: ბანკის გადარიცხვა, ნაღდი ფული მიწოდებისას, და სხვა მხარდაჭერილი მეთოდები. შეკვეთა დამუშავდება მხოლოდ გადახდის დადასტურების შემდეგ.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              ჩვენ ვიტოვებთ უფლებას, უარი ვთქვათ ან გავაუქმოთ ნებისმიერი შეკვეთა თაღლითური აქტივობის, არასწორი ინფორმაციის ან სხვა მიზეზით.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">5. მიწოდება და მონტაჟი</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              მიწოდების ვადები დამოკიდებულია პროდუქტის ხელმისაწვდომობაზე, მდებარეობაზე და შეკვეთის მოცულობაზე. სტანდარტული მიწოდების ვადა მითითებულია თითოეული პროდუქტის გვერდზე.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              მონტაჟის მომსახურება ხელმისაწვდომია შერჩეული პროდუქტებისთვის და მოითხოვს ცალკე შეთანხმებას. მონტაჟის ღირებულება და ვადა განისაზღვრება პროექტის სპეციფიკაციის მიხედვით.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">6. გარანტია და პასუხისმგებლობა</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              ყველა პროდუქტი მოყვება მწარმოებლის გარანტია, რომლის ვადა და პირობები მითითებულია თითოეულ პროდუქტზე. გარანტია ვრცელდება მხოლოდ მწარმოებლის მიერ დადგენილი პირობების დაცვის შემთხვევაში.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              Phoenix Georgia არ არის პასუხისმგებელი პირდაპირ, არაპირდაპირ ან შემთხვევითი ზიანისთვის, რომელიც შეიძლება გამოწვეული იყოს პროდუქტის არასწორი გამოყენებით, მონტაჟით ან შენახვით. პროდუქტის სწორი გამოყენებისთვის გთხოვთ, მიჰყვეთ მწარმოებლის ინსტრუქციებს.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">7. მესამე მხარის ბმულები</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              ჩვენი ვებსაიტი შესაძლოა შეიცავდეს ბმულებს მესამე მხარის ვებსაიტებზე. ეს ბმულები მოცემულია მხოლოდ თქვენი მოსახერხებლობისთვის. ჩვენ არ ვაკონტროლებთ და არ ვიღებთ პასუხისმგებლობას მესამე მხარის ვებსაიტების კონტენტზე, პოლიტიკაზე ან პრაქტიკაზე.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">8. კანონმდებლობა და დავები</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              ეს პირობები რეგულირდება საქართველოს კანონმდებლობით. ნებისმიერი დავა, რომელიც წარმოიშობა ამ პირობებიდან, გადაწყდება საქართველოს სასამართლოების მიერ. მხარეები ცდილობენ დავის მოგვარებას მოლაპარაკების გზით, სანამ სასამართლოს მიმართავენ.
            </p>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">9. კონტაქტი</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              თუ გაქვთ კითხვები ამ პირობების შესახებ, გთხოვთ დაგვიკავშირდეთ:
            </p>
            <div className="bg-[#F5F2EE] rounded-lg p-6 md:p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ელფოსტა</p>
                    <a href="mailto:info@phoenix.ge" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">info@phoenix.ge</a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ტელეფონი</p>
                    <a href="tel:+995599872020" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">+995 599 87 20 20</a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}